var exports = {
  "Lw": "VoiceRegionTeleportOverlay.module__overlay___SklTMF",
  "Vs": "VoiceRegionTeleportOverlay.module__tile___SklTMF",
  "Pf": "VoiceRegionTeleportOverlay.module__label___SklTMF",
};

module.exports = exports;
